export default __webpack_public_path__ + "static/media/devseeker.f3354fec.png";